import { render, staticRenderFns } from "./Composicao.vue?vue&type=template&id=a809ce30&scoped=true&"
import script from "./Composicao.vue?vue&type=script&lang=js&"
export * from "./Composicao.vue?vue&type=script&lang=js&"
import style0 from "./Composicao.vue?vue&type=style&index=0&id=a809ce30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a809ce30",
  null
  
)

export default component.exports